import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import PublicLead from "@/pages/PublicLead";
import EducationFair from "@/pages/EducationFair";
import RMDashboard from "@/pages/rm/RMDashboard";
import AddCustomer from "@/pages/rm/AddCustomer";
import MyCustomers from "@/pages/rm/MyCustomers";
import FollowUps from "@/pages/rm/FollowUps";
import CustomerProfile from "@/pages/CustomerProfile";
import BulkUpload from "@/pages/BulkUpload";
import NotificationsCenter from "@/pages/NotificationsCenter";
import SchoolDrive from "@/pages/SchoolDrive";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Analytics from "@/pages/admin/Analytics";
import CustomerDatabase from "@/pages/admin/CustomerDatabase";
import Mela from "@/pages/admin/Mela";
import MelaRoi from "@/pages/admin/MelaRoi";
import MelaBadges from "@/pages/admin/MelaBadges";
import Duplicates from "@/pages/admin/Duplicates";
import RMManagement from "@/pages/admin/RMManagement";
import BranchManagers from "@/pages/admin/BranchManagers";
import EduFair from "@/pages/admin/EduFair";
import ReferenceLinks from "@/pages/admin/ReferenceLinks";
import ExportData from "@/pages/admin/ExportData";

function Dashboard() {
  const { user } = useAuth();
  return (user?.role === "admin" || user?.role === "branch_manager") ? <AdminDashboard /> : <RMDashboard />;
}

function CustomersRoute() {
  const { user } = useAuth();
  return (user?.role === "admin" || user?.role === "branch_manager") ? <CustomerDatabase /> : <MyCustomers />;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (!user) return null;
  return user.role === "admin" ? children : <Navigate to="/app/dashboard" replace />;
}

function ManagerOnly({ children }) {
  const { user } = useAuth();
  if (!user) return null;
  return (user.role === "admin" || user.role === "branch_manager") ? children : <Navigate to="/app/dashboard" replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/apply/:token" element={<PublicLead />} />
            <Route path="/edu" element={<EducationFair />} />
            <Route path="/app" element={<Layout />}>
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="customers" element={<CustomersRoute />} />
              <Route path="customers/:id" element={<CustomerProfile />} />
              <Route path="add-customer" element={<AddCustomer />} />
              <Route path="followups" element={<FollowUps />} />
              <Route path="notifications" element={<NotificationsCenter />} />
              <Route path="schools" element={<SchoolDrive />} />
              <Route path="bulk-upload" element={<BulkUpload />} />
              <Route path="analytics" element={<ManagerOnly><Analytics /></ManagerOnly>} />
              <Route path="mela" element={<ManagerOnly><Mela /></ManagerOnly>} />
              <Route path="mela-roi" element={<ManagerOnly><MelaRoi /></ManagerOnly>} />
              <Route path="mela/:id/badges" element={<ManagerOnly><MelaBadges /></ManagerOnly>} />
              <Route path="duplicates" element={<AdminOnly><Duplicates /></AdminOnly>} />
              <Route path="rms" element={<ManagerOnly><RMManagement /></ManagerOnly>} />
              <Route path="branch-managers" element={<AdminOnly><BranchManagers /></AdminOnly>} />
              <Route path="edu-fair" element={<AdminOnly><EduFair /></AdminOnly>} />
              <Route path="reflinks" element={<AdminOnly><ReferenceLinks /></AdminOnly>} />
              <Route path="export" element={<ManagerOnly><ExportData /></ManagerOnly>} />
            </Route>
            <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
